<template>
  <div class="row justify-between q-mb-sm">
    <span class="">{{drink.name}}</span>
    <div class="row items-center">
      <DrinkTrendChip :difference="drink.difference"/>
      <span class="price">{{(drink.optimized_price).toFixed(2)}}€</span>
    </div>
  </div>
</template>
<script>
import DrinkTrendChip from "../components/DrinkTrendChip.vue";

export default {
  name: 'DrinkMobile',
  props: {
    drink: Object
  },
  components: {
    DrinkTrendChip
  },
  computed: {
    getPrefix() {
      if (this.drink.difference >= 0) {
        return "+"
      } else {
        return "-"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  font-weight: 800;
  font-family: sans-serif;
  color: white;
}
</style>